import { HkidValidator } from '../validators/HkidValidator.js';
import { TwidValidator } from '../validators/TwidValidator.js';
import { AadhaarValidator } from '../validators/AadhaarValidator.js';
import { NricValidator } from '../validators/NricValidator.js';
import { FinValidator } from '../validators/FinValidator.js';
import { PanValidator } from '../validators/PanValidator.js';
import { SsnValidator } from '../validators/SsnValidator.js';
import { SinValidator } from '../validators/SinValidator.js';
import { NinoValidator } from '../validators/NinoValidator.js';
import { BsnValidator } from '../validators/BsnValidator.js';
import { CpfValidator } from '../validators/CpfValidator.js';
import { RutValidator } from '../validators/RutValidator.js';
import { CuilValidator } from '../validators/CuilValidator.js';
import { RfcValidator } from '../validators/RfcValidator.js';
import { PersonalnummerValidator } from '../validators/PersonalnummerValidator.js';
import { PersonnummerValidator } from '../validators/PersonnummerValidator.js';
import { CprValidator } from '../validators/CprValidator.js';
import { PeselValidator } from '../validators/PeselValidator.js';
import { CnpValidator } from '../validators/CnpValidator.js';

// New validators
import { AusValidator } from '../validators/AusValidator.js';
import { NzValidator } from '../validators/NzValidator.js';
import { JpValidator } from '../validators/JpValidator.js';
import { KrValidator } from '../validators/KrValidator.js';
import { CnValidator } from '../validators/CnValidator.js';
import { ThValidator } from '../validators/ThValidator.js';
import { MyValidator } from '../validators/MyValidator.js';
import { PhValidator } from '../validators/PhValidator.js';
import { VnValidator } from '../validators/VnValidator.js';
import { IdValidator } from '../validators/IdValidator.js';
import { ZaValidator } from '../validators/ZaValidator.js';
import { EgValidator } from '../validators/EgValidator.js';
import { NgValidator } from '../validators/NgValidator.js';
import { KeValidator } from '../validators/KeValidator.js';
import { GhValidator } from '../validators/GhValidator.js';
import { FrValidator } from '../validators/FrValidator.js';
import { DeValidator } from '../validators/DeValidator.js';
import { ItValidator } from '../validators/ItValidator.js';
import { EsValidator } from '../validators/EsValidator.js';
import { PtValidator } from '../validators/PtValidator.js';
import { RuValidator } from '../validators/RuValidator.js';
import { UaValidator } from '../validators/UaValidator.js';
import { TrValidator } from '../validators/TrValidator.js';
import { IlValidator } from '../validators/IlValidator.js';
import { ArValidator } from '../validators/ArValidator.js';
import { SaValidator } from '../validators/SaValidator.js';
import { PkValidator } from '../validators/PkValidator.js';
import { BdValidator } from '../validators/BdValidator.js';
import { LkValidator } from '../validators/LkValidator.js';
import { MmValidator } from '../validators/MmValidator.js';

/**
 * Factory pattern for creating validators (Open/Closed Principle)
 * Easy to extend with new validators without modifying existing code
 */
export class ValidatorFactory {
  constructor() {
    this.validators = new Map([
      // Existing validators
      ['HKID', HkidValidator],
      ['TWID', TwidValidator],
      ['AADHAAR', AadhaarValidator],
      ['NRIC', NricValidator],
      ['FIN', FinValidator],
      ['PAN', PanValidator],
      ['SSN', SsnValidator],
      ['SIN', SinValidator],
      ['NINO', NinoValidator],
      ['BSN', BsnValidator],
      ['CPF', CpfValidator],
      ['RUT', RutValidator],
      ['CUIL', CuilValidator],
      ['RFC', RfcValidator],
      ['PERSONNUMMER', PersonnummerValidator],
      ['PERSONALNUMMER', PersonalnummerValidator],
      ['CPR', CprValidator],
      ['PESEL', PeselValidator],
      ['CNP', CnpValidator],
      
      // New comprehensive validators
      ['AUS', AusValidator],           // Australia - Tax File Number
      ['NZ', NzValidator],             // New Zealand - IRD Number
      ['JP', JpValidator],             // Japan - My Number
      ['KR', KrValidator],             // South Korea - RRN
      ['CN', CnValidator],             // China - Resident Identity Card
      ['TH', ThValidator],             // Thailand - National ID
      ['MY', MyValidator],             // Malaysia - NRIC
      ['PH', PhValidator],             // Philippines - UMID
      ['VN', VnValidator],             // Vietnam - Citizen Identity Card
      ['ID', IdValidator],             // Indonesia - NIK
      ['ZA', ZaValidator],             // South Africa - ID Number
      ['EG', EgValidator],             // Egypt - National ID
      ['NG', NgValidator],             // Nigeria - NIN
      ['KE', KeValidator],             // Kenya - National ID
      ['GH', GhValidator],             // Ghana - Ghana Card
      ['FR', FrValidator],             // France - INSEE Number
      ['DE', DeValidator],             // Germany - Tax ID
      ['IT', ItValidator],             // Italy - Fiscal Code
      ['ES', EsValidator],             // Spain - DNI
      ['PT', PtValidator],             // Portugal - Citizen Card
      ['RU', RuValidator],             // Russia - Passport Number
      ['UA', UaValidator],             // Ukraine - Tax Number
      ['TR', TrValidator],             // Turkey - TC Kimlik No
      ['IL', IlValidator],             // Israel - ID Number
      ['AR', ArValidator],             // UAE - Emirates ID
      ['SA', SaValidator],             // Saudi Arabia - National ID
      ['PK', PkValidator],             // Pakistan - CNIC
      ['BD', BdValidator],             // Bangladesh - National ID
      ['LK', LkValidator],             // Sri Lanka - National ID
      ['MM', MmValidator]              // Myanmar - NRC
    ]);
  }

  /**
   * Create validator instance
   */
  create(type) {
    const ValidatorClass = this.validators.get(type?.toUpperCase());
    if (!ValidatorClass) {
      throw new Error(`Unsupported ID type: ${type}`);
    }
    return new ValidatorClass();
  }

  /**
   * Register new validator (Open/Closed Principle)
   */
  register(type, ValidatorClass) {
    this.validators.set(type.toUpperCase(), ValidatorClass);
  }

  /**
   * Get supported types
   */
  getSupportedTypes() {
    return Array.from(this.validators.keys());
  }
}